import axios from '@/lib/AxApi';

export default {
  getColors(params, cb)
  {
    params.type = 'ordination';
    axios.get('/rest/ProteticColors/selectRow',
    {
      params: params
    })
    .then(response => {
      cb(response.data);
    })
    .catch(e => {
      //TODO
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/protetic_colors.js